import SynthesesShell from "./SynthesesShell";
import SynthesesFinanceursReadOnlyBoard from "./SynthesesFinanceursReadOnlyBoard";
import useSynthesesGroupedContractsRead from "./useSynthesesGroupedContractsRead";

function SynthesesFinanceurs() {
  const groupedContracts = useSynthesesGroupedContractsRead("financeurs");

  return (
    <SynthesesShell
      active="financeurs"
      title="Suivi de financements • Financeurs"
      description="Vue financeurs avec lecture des contrats existants et brouillons de nouveaux contrats."
    >
      <SynthesesFinanceursReadOnlyBoard
        data={groupedContracts.data}
        loading={groupedContracts.loading}
        error={groupedContracts.error}
        onRefreshData={groupedContracts.refetch}
        onMutateData={groupedContracts.setData}
        onRestoreData={groupedContracts.restoreData}
      />
    </SynthesesShell>
  );
}

export default SynthesesFinanceurs;
